var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h2',{class:[_vm.classes, _vm.title ? '' : 'noTitle']},[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.note)?_c('span',{class:_vm.classNote},[_vm._v(_vm._s(_vm.note))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }